/**
 * 通用日志工具
 * 根据环境变量控制日志输出
 * 开发环境：显示所有日志
 * 生产环境：只显示错误和警告日志
 */

// 判断是否为开发环境
const isDev = false; //process.env.NODE_ENV === 'development';

// 创建日志工具对象
const Logger = {
  /**
   * 调试日志 - 仅开发环境显示
   * @param {...any} args - 日志参数
   */
  log: (...args) => {
    if (isDev) {
      console.log(...args);
    }
  },

  /**
   * 信息日志 - 仅开发环境显示
   * @param {...any} args - 日志参数
   */
  info: (...args) => {
    if (isDev) {
      console.info(...args);
    }
  },

  /**
   * 调试日志 - 仅开发环境显示
   * @param {...any} args - 日志参数
   */
  debug: (...args) => {
    if (isDev) {
      console.debug(...args);
    }
  },

  /**
   * 警告日志 - 所有环境都显示
   * @param {...any} args - 日志参数
   */
  warn: (...args) => {
    console.warn(...args);
  },

  /**
   * 错误日志 - 所有环境都显示
   * @param {...any} args - 日志参数
   */
  error: (...args) => {
    console.error(...args);
  },

  /**
   * 表格日志 - 仅开发环境显示
   * @param {any} data - 要显示为表格的数据
   */
  table: (data) => {
    if (isDev && console.table) {
      console.table(data);
    }
  },

  /**
   * 分组开始 - 仅开发环境显示
   * @param {string} label - 分组标签
   */
  group: (label) => {
    if (isDev && console.group) {
      console.group(label);
    }
  },

  /**
   * 折叠分组开始 - 仅开发环境显示
   * @param {string} label - 分组标签
   */
  groupCollapsed: (label) => {
    if (isDev && console.groupCollapsed) {
      console.groupCollapsed(label);
    }
  },

  /**
   * 分组结束 - 仅开发环境显示
   */
  groupEnd: () => {
    if (isDev && console.groupEnd) {
      console.groupEnd();
    }
  },

  /**
   * 时间标记开始 - 仅开发环境显示
   * @param {string} label - 时间标记标签
   */
  time: (label) => {
    if (isDev && console.time) {
      console.time(label);
    }
  },

  /**
   * 时间标记结束 - 仅开发环境显示
   * @param {string} label - 时间标记标签
   */
  timeEnd: (label) => {
    if (isDev && console.timeEnd) {
      console.timeEnd(label);
    }
  },

  /**
   * 获取当前环境状态
   * @returns {boolean} 是否为开发环境
   */
  isDevelopment: () => isDev,

  /**
   * 强制输出日志（忽略环境限制）
   * @param {...any} args - 日志参数
   */
  force: (...args) => {
    console.log(...args);
  }
};

// 兼容旧版本的导出方式
export const logger = Logger;
export default Logger; 